import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NewcustomerComponent } from './newcustomer/newcustomer.component';
import { GenericlinkComponent } from './genericlink/genericlink.component';
import { DisplayDataComponent } from './display-data/display-data.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HeaderComponent } from './common/header/header.component';
import { FooterComponent } from './common/footer/footer.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TabsModule } from 'ngx-bootstrap';
import {HttpClientModule} from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { LocalStorageModule } from 'angular-2-local-storage';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { ModalModule } from 'ngx-bootstrap/modal';
import { InstabuserComponent } from './instabuser/instabuser.component';
import { ConvertintoIntPipe } from './convertinto-int.pipe';
import { DatePipe } from '@angular/common';
import { ThankYouComponent } from './thank-you/thank-you.component';
import { FailedComponent } from './failed/failed.component';
import { RpupisuccessComponent } from './RazorPayUPIResponsePage/rpupisuccess/rpupisuccess.component';
import { RpupifailureComponent } from './RazorPayUPIResponsePage/rpupifailure/rpupifailure.component';

@NgModule({
  declarations: [
    AppComponent,
    NewcustomerComponent,
    GenericlinkComponent,
    DisplayDataComponent,
    DashboardComponent,
    HeaderComponent,
    FooterComponent,
    InstabuserComponent,
    ConvertintoIntPipe,
    ThankYouComponent,
    FailedComponent,
    RpupisuccessComponent,
    RpupifailureComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgxSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    TabsModule.forRoot(),
    BsDatepickerModule.forRoot(),
    HttpClientModule,
    AngularFontAwesomeModule,
    HttpModule,
    BrowserAnimationsModule, // required animations module
    ToastrModule.forRoot({
      timeOut: 60000,
      positionClass: 'toast-top-center',
      preventDuplicates: true,
      closeButton:true,
      
    }) ,// ToastrModule added
    LocalStorageModule.forRoot({
      prefix: 'my-app',
      storageType: 'localStorage'
  }), ModalModule.forRoot()
  ],
  providers: [DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
